import {
  Entitlement,
  EntitlementStatus,
} from '@src/global/requests/entitlements';

const getDateOnly = (date: Date): Date => {
  const d = new Date(date);
  d.setUTCHours(0, 0, 0, 0);
  return d;
};

const normalizeSku = (value: string | null | undefined): string =>
  (value || '').trim().toLowerCase();

export const hasActiveEntitlementForSku = (
  entitlements: Entitlement[],
  productSku: string | null
): boolean => {
  const normalizedProductSku = normalizeSku(productSku);
  if (!normalizedProductSku) return false;

  const today = getDateOnly(new Date());

  return entitlements.some((ent) => {
    if (
      normalizeSku(ent.sku) !== normalizedProductSku ||
      ent.status !== EntitlementStatus.ACTIVE
    ) {
      return false;
    }

    const startDate = getDateOnly(new Date(ent.entitlementStartDate));
    const endDate = getDateOnly(new Date(ent.entitlementEndDate));

    return startDate <= today && endDate >= today;
  });
};

export const hasActiveEntitlementForSite = (
  entitlements: Entitlement[],
  sitePrefix: string | null
): boolean => {
  const normalizedSitePrefix = normalizeSku(sitePrefix);
  if (!normalizedSitePrefix || !entitlements || entitlements.length === 0)
    return false;

  const today = getDateOnly(new Date());

  return entitlements.some((ent) => {
    // Check if SKU starts with the site prefix (e.g., "vet_", "ags_")
    if (
      !normalizeSku(ent.sku).startsWith(normalizedSitePrefix) ||
      ent.status !== EntitlementStatus.ACTIVE
    ) {
      return false;
    }

    const startDate = getDateOnly(new Date(ent.entitlementStartDate));
    const endDate = getDateOnly(new Date(ent.entitlementEndDate));

    return startDate <= today && endDate >= today;
  });
};
